module.exports = {"431230100":"双江镇","431230101":"县溪镇","431230102":"播阳镇","431230104":"牙屯堡镇","431230105":"菁芜洲镇","431230106":"溪口镇","431230107":"陇城镇","431230108":"万佛山镇","431230109":"独坡镇","431230203":"大高坪苗族乡","431230216":"坪坦乡","431230400":"通道县地连林场","431230401":"通道县播阳农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431230.json
// module id = 1927
// module chunks = 0